var shop = new function () {
    this.cache = {};
    this.defaultSort = 'bestsellers';
    this.largeCylinderPromptShown = false;
    this.doLoad = function (event, el) {
        var $el = $(el);
        if ($el.is('select') || $el.is('a') || $el.is('button') || $el.is('input') || $el.is('li')) {
            this.setFilterVisibility();
            $('.shop-page').val(($el.data('page') ? $el.data('page') : 1));
            listFilter.doStateChange();
        }
        this.doAjaxLoad();
    };
    this.doFilterClick = function (event, el) {
        event.stopPropagation();
        $(el).parent().toggleClass('open');
    };
    this.doFilterPanelClick = function (event, el) {
        event.stopPropagation();
    };
    this.doPriceKeyUp = function (event, el) {
        var keyCode = (event.keyCode ? event.keyCode : event.which);
        if (keyCode == 9) {
            $(el).closest('.product-filter-panel').find('.text-input.' + ($(el).hasClass('min') ? 'max' : 'min')).focus();
        } else if (keyCode == 13) {
            event.preventDefault();
            $(el).trigger('change');
        }
    };
    this.setFilterFromUrl = function () {
        var urlParts = window.location.pathname.split('/'),
            urlFilters = {},
            currentFilter,
            $innerPanel;
        $.each(urlParts, function (key, urlPart) {
            if (key%2 == 0) {
                if (urlPart.length && urlPart != 'page' && urlPart != 'category') {
                    urlFilters[urlPart] = urlParts[key + 1].split(',');
                }
            }
        });
        $('.product-filter').each(function () {
            $innerPanel = $(this).find('.product-filter-panel');
            currentFilter = $(this).data('filter');
            if ($innerPanel.hasClass('product-filter-panel--checkboxes')) {
                currentFilter = currentFilter.substr(3); // Remove the pa_
                $innerPanel.find('.product-filter-panel__item').removeClass('selected');
                if (typeof urlFilters[currentFilter] != 'undefined') {
                    $.each(urlFilters[currentFilter], function (key, filterValue) {
                        $innerPanel.find('.product-filter-panel__item[data-item="' + filterValue + '"]').addClass('selected');
                    });
                }
            } else {
                $innerPanel.find('.min').val();
                $innerPanel.find('.max').val();
                if (typeof urlFilters[currentFilter] != 'undefined') {
                    $innerPanel.find('.min').val(urlFilters[currentFilter][0]);
                    if (urlFilters[currentFilter].length > 1) {
                        $innerPanel.find('.max').val(urlFilters[currentFilter][1]);
                    }
                }
            }
        });
    };
    this.setFilterVisibility = function () {
        var category = $('.shop-category').val(),
            attributes = categoryAttributes[category],
            filters = $('.product-filter.option:not([data-filter="price"])');
        filters.removeClass('hide');
        if (category && category != 'all') {
            filters.each(function () {
                if (attributes.indexOf($(this).data('filter')) == -1) {
                    $(this).addClass('hide');
                }
            });
        }
        this.setFilterTitle();
    };
    this.setFilterTitle = function () {
        var filters = this.getFilters(),
            filterCount = 0;
        $.each(filters, function(filterType, filterValue) {
            if (!$('.product-filter[data-filter="' + filterType + '"]').hasClass('hide')) {
                filterCount += (filterType == 'price' ? 1 : filterValue.length);
            }
        });
        $('.product-filters').find('.current').text((filterCount > 0 ? 'Current filters (' + filterCount + ')' : 'Please select'));
    };
    this.setFilter = function (event, el) {
        event.stopPropagation();
        $(el).toggleClass('selected');
        this.doLoad(event, el);
        this.setFilterTitle();
    };
    this.getFilters = function () {
        var filters = {},
            currentFilter,
            $innerPanel,
            min, max;
        $('.product-filter:not(.hide)').each(function () {
            $innerPanel = $(this).find('.product-filter-panel');
            currentFilter = $(this).data('filter');
            if ($innerPanel.hasClass('product-filter-panel--checkboxes')) {
                if ($(this).find('.product-filter-panel__item.selected').length) {
                    filters[currentFilter] = [];
                    $(this).find('.product-filter-panel__item.selected').each(function () {
                        filters[currentFilter].push($(this).data('item'));
                    });
                }
            } else {
                min = $(this).find('.min').val();
                max = $(this).find('.max').val();
                if (max.length) max = parseFloat(max);
                if (min.length || max > 0) {
                    min = (min.length ? parseFloat(min) : 0);
                    if (isNaN(min)) min = 0;
                    if (isNaN(max)) max = 0;
                    if (max > 0 && max < min) {
                        min = 0;
                        $(this).find('.min').val('')
                    }
                    if (min < 0) {
                        min = 0;
                        $(this).find('.min').val(0)
                    }
                    if (max < 0) {
                        max = 0;
                        $(this).find('.max').val(0)
                    }
                    filters[currentFilter] = [min, max];
                }
            }
        });
        return filters;
    };
    this.getFiltersQueryString = function () {
        var filters = this.getFilters(),
            firstFilter = Object.keys(filters)[0],
            filter = filters[firstFilter],
            filtersPath = '',
            filtersQueryString = '';
        if (firstFilter && firstFilter.substr(0, 3) == 'pa_') {
            filtersPath += '/' + firstFilter.substr(3) + '/' + filter[0];
        }
        if (window.location.search.indexOf('product-descriptions') != -1) {
            filtersQueryString += '&product-descriptions';
        }
        $.each(filters, function(filter, values) {
            if (filter != 'price' && filter == firstFilter) values.shift();
            if (values.length) {
                filtersQueryString += '&' + (filter == shop.defaultSort ? filter : filter.substr(3)) + '=' + values.join(',');
            }
        });
        if (filtersQueryString.length) filtersQueryString = '?' + filtersQueryString.substr(1);
        return filtersPath + filtersQueryString;
    };
    this.setLoading = function (loading) {
        listFilter.doScrollTop();
        $('.shop-list')[(loading ? 'add' : 'remove') + 'Class']('loading');
        $('.shop-category, .shop-filters, .shop-sort').prop('disabled', loading);
    };
    this.doAjaxLoad = function () {
        var $shopList = $('.shop-list'),
            ajaxData = {
                action: 'flogas_shop_get_products',
                category: $('.shop-category').val(),
                filters: shop.getFilters(),
                sort: $('.shop-sort').val(),
                page: $('.shop-page').val(),
                productDescriptions: (window.location.search.indexOf('product-descriptions') != -1),
                _wpnonce: $shopList.data('nonce')
            },
            cacheKey = ajaxData.category + ':' + ajaxData.page + ':' + ajaxData.sort + ':';
        $.each(ajaxData.filters, function(filter, values) {
            cacheKey += filter + '-' + values.join(',');
        });
        shop.setLoading(true);
        $('.shop-content').html('');
        if (typeof shop.cache[cacheKey] != 'undefined') {
            $shopList.html(shop.cache[cacheKey].productList);
            $('h1.shop-title-1').html(shop.cache[cacheKey].title);
            $('.shop-content').html(shop.cache[cacheKey].shopContent);
            shop.setLoading(false);
            data.setCss();
        } else {
            if (typeof this.xhr == 'object') this.xhr.abort();
            this.xhr = $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: ajaxData,
                success: function (json) {
                    if (typeof json.data.shopInMaintenance !== 'undefined') {
                        window.location = '/shop/maintenance';
                    }
                    if (typeof json.data.shopInvalidAccount !== 'undefined') {
                        window.location = '/shop/invalid-account';
                    }
                    shop.cache[cacheKey] = json.data;
                    shop.setLoading(false);
                    $shopList.html(json.data.productList);
                    $('h1.shop-title-1').html(json.data.title);
                    $('.shop-content').html(json.data.shopContent);
                }
            });
        }
        this.showLargeCylinderLoginPrompt();
    };
    this.doResetFilters = function (event, el) {
        $('#product-filter-min, #product-filter-max').val('');
        $('.product-filter-panel__item').removeClass('focus selected');
        $('.shop-category').trigger('change').trigger('update');
        listFilter.doToggle(event, el);
    };
    this.initCarousel = function () {
        $('.shop-reasons-inner-carousel:not(.slick-initialized)').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            autoplay: false,
            prevArrow: '<span class="slick-prev"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14 fa-3x"><path fill="#fff" d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z" class=""></path></svg></span>',
            nextArrow: '<span class="slick-next"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14 fa-3x"><path fill="#fff" d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z" class=""></path></svg></span>',
            responsive: [
                {
                    breakpoint: 9999,
                    settings: 'unslick'
                },
                {
                    breakpoint: 992
                }
            ]
        });
    };
    this.showLargeCylinderLoginPrompt = function () {
        if (!this.largeCylinderPromptShown && $('.shop-category').val() === 'large-cylinder-size') {
            this.largeCylinderPromptShown = true;
            $('#large-cylinder-login-prompt-modal').addClass('flogas-alert-manual-modal--open');
        }
    };
    this.closeLargeCylinderLoginPrompt = function () {
        $('#large-cylinder-login-prompt-modal').removeClass('flogas-alert-manual-modal--open');
    };
    this.clickLargeCylinderLoginPrompt = function (event) {
        event.stopPropagation();
    };
};

data.getSlick('shop', 'initCarousel');

listFilter.setPageClass('.shop-page');
listFilter.setVariables({
    category: {prefix: 'category', identifier: '.shop-category'},
    filters: {identifier: '.shop-category', getData: 'shop.getFiltersQueryString'},
    sort: {queryString: true, identifier: '.shop-sort', default: shop.defaultSort}
});
window.onpopstate = function (event) {
    listFilter.setParamsFromUrl();
    shop.setFilterFromUrl();
    shop.doLoad();
};
shop.showLargeCylinderLoginPrompt();